import { useEffect, useRef, useState } from "react";
import { Users, Building2, MapPin, CalendarDays, Globe2, BarChart3 } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = { professionals: Users, organisations: Building2, venues: MapPin, events: CalendarDays, countries: Globe2, indices: BarChart3 };

function Counter({ value }) {
  const num = parseFloat(value), suffix = value.replace(/[\d.]/g, "");
  const [n, setN] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const el = ref.current;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      const t0 = performance.now();
      const step = (t) => { const k = Math.min(1, (t - t0) / 1200); setN(num * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step); io.disconnect();
    }, { threshold: 0.3 });
    if (el) io.observe(el);
    return () => io.disconnect();
  }, [num]);
  return <span ref={ref}>{Number.isInteger(num) ? Math.round(n) : (n >= num ? num : n).toFixed(1)}{suffix}</span>;
}

export function StatsBar() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  return (
    <section data-testid="stats-bar" className="border-y border-[#E6E3DC] bg-ivory">
      <div className="container-wei py-5 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-y-5 xl:divide-x divide-[#E6E3DC]">
        {(stats?.display || Array(6).fill(null)).map((s, i) => {
          const Icon = s ? ICONS[s.key] : Users;
          return (
            <div key={i} className="flex items-center gap-3 xl:px-6 first:xl:pl-0" data-testid={s ? `stat-${s.key}` : undefined}>
              <Icon className="w-8 h-8 text-gold shrink-0" strokeWidth={1.2} />
              <div>
                <div className="font-serif text-2xl font-semibold leading-none text-ink">{s ? <Counter value={s.value} /> : "—"}</div>
                <div className="text-[11px] text-charcoal mt-1">{s?.label || "Loading"}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
